function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import { withIllustrationWrapper } from '../../components/atoms/Illustration/withIllustrationWrapper';
import { jsx as ___EmotionJSX } from "@emotion/react";

var IllustrationDragAndDrop = function IllustrationDragAndDrop(props, ref) {
  return ___EmotionJSX("svg", _extends({
    width: "138",
    height: "124",
    viewBox: "0 0 138 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), ___EmotionJSX("path", {
    d: "M0.877733 37.105C1.01364 34.7577 47.4034 -0.476315 51.6755 0.00488365C55.9475 0.486083 87.0491 89.3609 86.7185 95.8773C86.3879 102.394 35.873 120.143 32.0602 118.413C28.2473 116.683 0.44796 44.7454 0.877733 37.105Z",
    fill: "url(#paint0_linear_144_8415)"
  }), ___EmotionJSX("path", {
    d: "M9.44385 48.356C15.9749 45.6599 44.1122 29.0971 46.746 24.3145Z",
    fill: "#6AC2BF"
  }), ___EmotionJSX("path", {
    d: "M13.9839 57.8443C20.5113 55.1481 48.6522 38.589 51.2823 33.8027Z",
    fill: "#6AC2BF"
  }), ___EmotionJSX("path", {
    d: "M17.7197 67.1487C24.2508 64.4525 36.784 58.4284 39.4177 53.6421Z",
    fill: "#6AC2BF"
  }), ___EmotionJSX("path", {
    d: "M54.7867 86.3267C55.2126 85.233 55.8035 84.211 56.5389 83.2962C57.2968 82.374 58.203 81.5845 59.2204 80.96C60.2422 80.355 61.3228 79.8553 62.4456 79.4687C62.9929 79.2667 63.5475 79.083 64.0691 78.881C64.5653 78.7103 65.0315 78.4624 65.4503 78.1463C65.6116 78.0282 65.7406 77.8715 65.8253 77.6904C65.9101 77.5094 65.9478 77.3099 65.9352 77.1104C65.8884 76.6502 65.7183 76.2112 65.4429 75.8395C64.8074 74.9812 64.0038 74.2613 63.081 73.7237C62.1903 73.1437 61.1902 72.7524 60.1424 72.5739C59.9205 72.5445 59.6957 72.5445 59.4738 72.5739C59.315 72.5969 59.1639 72.6573 59.0331 72.7503C58.9279 72.8472 58.8581 72.9765 58.8347 73.1176C58.8347 73.1617 58.8347 73.2057 58.8053 73.2498C58.7759 73.2939 58.8053 73.3711 58.8053 73.4298C58.7957 73.5521 58.7957 73.6749 58.8053 73.7972C58.8289 74.7931 59.2216 75.7448 59.9073 76.4676C60.6439 77.2715 61.4911 77.9666 62.4235 78.532C63.3863 79.1359 64.3793 79.69 65.3988 80.1923C66.4236 80.7102 67.4706 81.2135 68.5065 81.7902C68.7673 81.9371 69.028 82.0877 69.2851 82.253C69.5712 82.4254 69.8383 82.6273 70.0822 82.8554C70.2334 83.0108 70.351 83.1958 70.4275 83.3986C70.504 83.6015 70.5378 83.818 70.5268 84.0346C70.4875 84.425 70.3299 84.7941 70.075 85.0925C69.8544 85.3547 69.5926 85.5792 69.2999 85.7573C69.0092 85.9369 68.6879 86.0614 68.3521 86.1247C68.1587 86.1563 67.9615 86.1563 67.7681 86.1247C67.6566 86.1001 67.5481 86.0632 67.4448 86.0145C67.3352 85.9535 67.238 85.8725 67.1583 85.7757C67.1216 85.7279 67.0848 85.6765 67.0518 85.6251C67.0284 85.5739 67.0088 85.5211 66.993 85.4671L66.9453 85.3092V85.1659C66.9345 84.9863 66.9468 84.8061 66.982 84.6296C67.1369 84.0326 67.3848 83.4636 67.7167 82.9436C68.0155 82.4348 68.3442 81.9442 68.7011 81.4743C69.4094 80.5486 70.1647 79.6597 70.9639 78.8112C70.2953 79.7589 69.6378 80.7176 69.0391 81.702C68.7489 82.1979 68.4587 82.6901 68.2199 83.2044C67.9643 83.6863 67.7869 84.2059 67.6946 84.7435C67.6546 84.9185 67.6822 85.1022 67.7718 85.2578C67.7718 85.2835 67.8085 85.2578 67.8195 85.2945L67.9077 85.3129C68.0017 85.3131 68.0955 85.302 68.1868 85.2798C68.6436 85.1362 69.0425 84.8505 69.3256 84.4643C69.4436 84.3149 69.5128 84.1328 69.524 83.9427C69.5202 83.8722 69.5019 83.8031 69.4703 83.7399C69.4387 83.6767 69.3945 83.6207 69.3403 83.5754C69.1482 83.4227 68.9429 83.2875 68.7268 83.1713C68.488 83.0354 68.2383 82.9069 67.9921 82.7783C65.9498 81.7975 63.7643 80.9159 61.7109 79.6854C60.646 79.0668 59.6801 78.2917 58.8457 77.3859C58.4069 76.9003 58.0451 76.3503 57.7731 75.755C57.4961 75.1339 57.3498 74.4625 57.3433 73.7825C57.3408 73.6131 57.3494 73.4438 57.3691 73.2755C57.3691 73.1911 57.3691 73.1102 57.3948 73.0221L57.4572 72.7282C57.5641 72.2976 57.8045 71.9118 58.1441 71.6262C58.4777 71.3682 58.8727 71.2012 59.2902 71.1414C59.6424 71.0935 59.9995 71.0935 60.3517 71.1414C60.9851 71.2315 61.6031 71.4082 62.1884 71.6666C62.7607 71.9058 63.3093 72.1986 63.8267 72.5409C64.892 73.2031 65.8086 74.0785 66.5192 75.1122C66.9185 75.6918 67.1429 76.3739 67.1657 77.0774C67.163 77.461 67.0698 77.8385 66.8938 78.1794C66.7143 78.5097 66.4633 78.7958 66.1592 79.0169C65.6297 79.3752 65.0471 79.6479 64.4328 79.825C63.8634 80.0123 63.305 80.1703 62.7541 80.3282C61.6586 80.6229 60.5954 81.0265 59.5804 81.5331C58.5705 82.0445 57.6482 82.7128 56.8475 83.513C56.0357 84.3527 55.3424 85.2994 54.7867 86.3267V86.3267Z",
    fill: "#6AC2BF"
  }), ___EmotionJSX("path", {
    d: "M79.1625 18.9067C81.6934 16.4786 135.47 40.3806 137.061 44.1971C138.651 48.0137 111.436 114.221 94.3185 123.54C90.5166 125.608 40.8392 94.9581 39.8438 91.9497C38.8483 88.9413 46.5218 87.9091 54.8381 72.654C60.9541 61.4322 76.2459 21.7057 79.1625 18.9067Z",
    fill: "url(#paint1_linear_144_8415)"
  }), ___EmotionJSX("path", {
    d: "M85.1646 28.9932C83.6953 34.7161 81.8587 40.4024 79.8751 45.9159C78.3029 50.2504 76.3671 55.6428 73.0538 58.6732C71.0004 60.5503 68.6202 62.4383 69.1087 64.3301C69.5973 66.2218 73.3844 65.0647 75.1072 65.6818C76.8299 66.2989 76.1026 68.7417 79.2727 69.4175C82.4427 70.0934 84.1544 68.2752 85.3078 66.3467C86.4613 64.4182 85.2417 62.4898 84.1655 60.9396C82.0423 57.8761 83.7982 51.1724 84.8303 47.1942C86.2666 41.7394 87.7689 36.1965 89.0766 30.6645C87.4971 29.9739 86.7147 29.6433 85.1646 28.9932Z",
    fill: "url(#paint2_linear_144_8415)"
  }), ___EmotionJSX("path", {
    d: "M45.5814 92.7799C51.9072 87.9768 57.4137 82.1813 61.8871 75.6183C65.9754 69.7411 63.294 68.4812 64.5208 66.909C65.7477 65.3369 67.5733 67.2359 70.2291 67.3792C72.8849 67.5224 71.7829 66.7143 73.8656 67.3572C75.9484 68 74.9015 70.1305 76.4369 70.6851C77.9724 71.2398 80.0368 70.3178 79.5409 71.7871C79.045 73.2564 77.616 74.5458 74.6003 75.2253C70.2217 76.2171 66.5191 81.6793 63.3344 85.1432C59.69 89.0495 55.737 92.6561 51.5138 95.9279L45.5814 92.7799Z",
    fill: "url(#paint3_linear_144_8415)"
  }), ___EmotionJSX("path", {
    d: "M118.444 43.0654C115.708 50.232 112.935 57.9422 108.159 64.0508C104.618 68.5616 103.472 69.7591 100.927 70.4828C100.076 70.7254 99.289 71.1522 98.6218 71.7331C97.9546 72.314 97.4234 73.0346 97.066 73.8438C96.6986 74.5785 95.1449 77.7852 98.1459 78.7991C101.147 79.8129 101.625 78.0166 104.784 79.6733C107.943 81.3299 108.303 83.1849 110.958 84.2795C113.614 85.3742 114.999 83.9122 115.546 82.0058C116.094 80.0994 114.161 78.0203 114 76.0515C113.632 71.8051 115.862 66.7397 117.35 62.5448C119.355 56.877 121.758 51.1576 123.723 45.3575C121.552 44.4135 120.501 43.9544 118.444 43.0654Z",
    fill: "url(#paint4_linear_144_8415)"
  }), ___EmotionJSX("path", {
    d: "M74.8832 108.851C79.2911 105.339 83.7431 101.739 87.6111 97.6398C91.8317 93.1731 91.5525 92.3981 92.8014 90.106C94.0503 87.8139 94.5205 85.9662 94.5793 83.1818C94.638 80.3975 94.212 78.818 95.1817 79.0972C96.1514 79.3763 96.6804 81.1652 98.3371 81.2718C99.9937 81.3783 101.217 80.3718 104.163 81.7897C107.109 83.2076 106.686 85.0369 108.288 85.8633C109.889 86.6898 111.436 85.9258 111.315 87.5824C111.193 89.2391 111.182 90.6386 108.839 90.7598C106.495 90.881 102.653 93.085 101.125 94.2678C94.4617 99.4104 88.0739 106.503 80.6612 111.738C78.2956 110.581 77.1606 110 74.8832 108.851Z",
    fill: "url(#paint5_linear_144_8415)"
  }), ___EmotionJSX("defs", null, ___EmotionJSX("linearGradient", {
    id: "paint0_linear_144_8415",
    x1: "1.5327",
    y1: "35.8696",
    x2: "91.5443",
    y2: "87.836",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D1EAF1"
  }), ___EmotionJSX("stop", {
    offset: "0.36",
    stopColor: "#CEE9F0"
  }), ___EmotionJSX("stop", {
    offset: "0.59",
    stopColor: "#C6E5EC"
  }), ___EmotionJSX("stop", {
    offset: "0.78",
    stopColor: "#B7DFE5"
  }), ___EmotionJSX("stop", {
    offset: "0.95",
    stopColor: "#A2D7DB"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9BD4D7"
  })), ___EmotionJSX("linearGradient", {
    id: "paint1_linear_144_8415",
    x1: "171173",
    y1: "132363",
    x2: "187835",
    y2: "150464",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#50B3CA"
  }), ___EmotionJSX("stop", {
    offset: "0.27",
    stopColor: "#4BADC8"
  }), ___EmotionJSX("stop", {
    offset: "0.63",
    stopColor: "#3E9BC1"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#2A82B8"
  })), ___EmotionJSX("linearGradient", {
    id: "paint2_linear_144_8415",
    x1: "-2960.44",
    y1: "72554.5",
    x2: "-2152.95",
    y2: "72946.6",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D1EAF1"
  }), ___EmotionJSX("stop", {
    offset: "0.36",
    stopColor: "#CEE9F0"
  }), ___EmotionJSX("stop", {
    offset: "0.59",
    stopColor: "#C6E5EC"
  }), ___EmotionJSX("stop", {
    offset: "0.78",
    stopColor: "#B7DFE5"
  }), ___EmotionJSX("stop", {
    offset: "0.95",
    stopColor: "#A2D7DB"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9BD4D7"
  })), ___EmotionJSX("linearGradient", {
    id: "paint3_linear_144_8415",
    x1: "20963.7",
    y1: "67585",
    x2: "22748.6",
    y2: "68451.7",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D1EAF1"
  }), ___EmotionJSX("stop", {
    offset: "0.36",
    stopColor: "#CEE9F0"
  }), ___EmotionJSX("stop", {
    offset: "0.59",
    stopColor: "#C6E5EC"
  }), ___EmotionJSX("stop", {
    offset: "0.78",
    stopColor: "#B7DFE5"
  }), ___EmotionJSX("stop", {
    offset: "0.95",
    stopColor: "#A2D7DB"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9BD4D7"
  })), ___EmotionJSX("linearGradient", {
    id: "paint4_linear_144_8415",
    x1: "7896.21",
    y1: "79584.6",
    x2: "9256.58",
    y2: "80245.2",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D1EAF1"
  }), ___EmotionJSX("stop", {
    offset: "0.36",
    stopColor: "#CEE9F0"
  }), ___EmotionJSX("stop", {
    offset: "0.59",
    stopColor: "#C6E5EC"
  }), ___EmotionJSX("stop", {
    offset: "0.78",
    stopColor: "#B7DFE5"
  }), ___EmotionJSX("stop", {
    offset: "0.95",
    stopColor: "#A2D7DB"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9BD4D7"
  })), ___EmotionJSX("linearGradient", {
    id: "paint5_linear_144_8415",
    x1: "24677.5",
    y1: "75364",
    x2: "26824.9",
    y2: "76406.7",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D1EAF1"
  }), ___EmotionJSX("stop", {
    offset: "0.36",
    stopColor: "#CEE9F0"
  }), ___EmotionJSX("stop", {
    offset: "0.59",
    stopColor: "#C6E5EC"
  }), ___EmotionJSX("stop", {
    offset: "0.78",
    stopColor: "#B7DFE5"
  }), ___EmotionJSX("stop", {
    offset: "0.95",
    stopColor: "#A2D7DB"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9BD4D7"
  }))));
};

export default withIllustrationWrapper( /*#__PURE__*/forwardRef(IllustrationDragAndDrop));
//# sourceMappingURL=IllustrationDragAndDrop.js.map